import React from 'react';

import MediaQuery from 'react-responsive';
import { compose } from 'recompose';

import CustomLink from 'components/CustomLink/CustomLink';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { device } from 'helpers/screenSizes';
import { isMarketsPage } from 'helpers/utils';
import useMediaQuery from 'hooks/useMediaQuery';
import { DeltaIndiaLogoMobile, DeltaIndiaLogo } from 'styles/assets/icons';
import mobileLogoPath from 'styles/assets/logo.png';
import { DeltaExchange } from 'styles/assets/logos';

import { BrandWrapper } from '../header_style';

const MobileLogo = () => {
  let logo = IS_INDIAN_EXCHANGE ? (
    <DeltaIndiaLogoMobile className="logo-small" />
  ) : (
    <img
      src={mobileLogoPath}
      className="logo-small"
      alt="logo"
      data-palette="logo" />
  );

  if (isMarketsPage()) {
    logo = <DeltaExchange />;
  }

  return logo;
};

export const LogoComponentBase = ({ showBorder }) => {
  const { whenBelowMd } = useMediaQuery();

  const classNames = isMarketsPage()
    ? 'col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-xxs-8 col-xs-8 col-sm-5 mobile-height band-wrapper'
    : 'col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-xxs-4 mobile-height band-wrapper';

  return (
    <BrandWrapper showBorder={showBorder} className={classNames}>
      <div
        className="org-logo"
        style={{
          padding: isMarketsPage() && whenBelowMd ? '8px 9px' : '9px',
        }}
      >
        <CustomLink className="brand" href={window.isRNWebView ? '/app' : '/'}>
          <div>
            <MediaQuery query={device.up.xs}>
              {IS_INDIAN_EXCHANGE ? <DeltaIndiaLogo height={31} /> : <DeltaExchange />}
            </MediaQuery>
            <MediaQuery query={device.down.xs}>
              <MobileLogo />
            </MediaQuery>
          </div>
        </CustomLink>
      </div>
    </BrandWrapper>
  );
};

const enhance = compose(React.memo);
export const LogoComponent = enhance(LogoComponentBase);
